module.exports = __webpack_public_path__ + "img/gshock_method_en.2b9c3bdd.png";